import { render, staticRenderFns } from "./LoginRetail.vue?vue&type=template&id=2ce82b2e"
import script from "./LoginRetail.vue?vue&type=script&lang=js"
export * from "./LoginRetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports